module.exports = __webpack_public_path__ + "img/img_4.e2421812.png";